import { render, staticRenderFns } from "./UpdateVersionV2.vue?vue&type=template&id=61261cea&scoped=true"
import script from "./UpdateVersionV2.vue?vue&type=script&lang=js"
export * from "./UpdateVersionV2.vue?vue&type=script&lang=js"
import style0 from "vue-select/dist/vue-select.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./UpdateVersionV2.vue?vue&type=style&index=1&id=61261cea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61261cea",
  null
  
)

export default component.exports